// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3AMuk","controls":"styles_controls__YhAr-","charLimit":"styles_charLimit__B_k0Y","input":"styles_input__1JWHd","send":"styles_send__1o7FN"};